import { Button, CircularProgress } from "@material-ui/core";
import React from "react";

function LoadingButton({ children, loading = false, ...props }) {
  return (
    <Button disabled={loading} {...props}>
      {loading ? (
        <CircularProgress style={{ color: "white", height: 25, width: 25 }} />
      ) : (
        children
      )}
    </Button>
  );
}

export default LoadingButton;
